import { Router } from '@angular/router';
import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { RouteInfoService } from 'src/app/services/route-info.service';
import { WholeHist } from 'src/app/services/api-service/hist/whole-hist';
import { MultiPrescriptWrite } from 'src/app/shared/hcr-lib/MultiPrescriptWrite';
import { TreatmentData } from 'src/app/shared/hcr-lib/TreatmentData';
import { HistApi } from 'src/app/services/api-service/hist/hist-api';

import { PrescriptionSignMultiWrite } from 'src/app/shared/hcr-lib/PrescriptionSignMultiWrite';

import { UserCache } from 'src/app/services/user-cache';

import { CashierPreview, IPricingApi, PricingApi, PricingEditOpt, PricingEditOpt2 } from 'src/app/services/api-service/pricing/pricing-api';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { Rx } from '../../models/rx';
import { UserConfirmService } from 'src/app/services/user-confirm.service';
import { HistOrder } from '../models/hist-order';
import { Distinct, NullOrEmptyTrim } from 'src/app/shared/utilities';
import { ClinicTypeEnum } from 'src/app/enums/ClinicTypeEnum';
import { Clinic } from 'src/app/system/clinic/models/clinic';
import { MemoryCache } from 'src/app/services/memory-cache-service';
import { OptionTypes } from 'src/app/services/cache-service/options-cached.service';
import { DiscountTypeEnum } from 'src/app/enums/DiscountTypeEnum';
import { ExpenseItemEnum } from 'src/app/enums/ExpenseItemEnum';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { PricingChiApi } from 'src/app/services/api-service/pricing/pricing-chi-api';
import { MedRxType, OrderTypeEnum } from 'src/app/enums/OrderTypeEnum';
import { DispensingGroup, DispensingTypeEnum, OrderDispensingTypeEnum } from 'src/app/enums/DispensingTypeEnum';
import { P } from '@angular/cdk/keycodes';
import { RatingPrice共同藥品UISet, RatingPrice特殊轉代UISet } from '../rating-price/models/priceothercontrol';
import { RegisterConst } from 'src/app/shared/constants/register-const';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { LabHospSPRule } from 'src/app/enums/OrderSpecialRuleEnum';
import { PriceNhiDrugcodes } from '../rating-price/models/priceNhicodes';

export class DaysInfo {
  DrugDays: number = 0;
  PresDays: number = 0;
  NormalDays: number = 0;
  isApplyingPres = false;
  // OralDrugDays: number = 0;
  // OtherDrugDays : number = 0;
  // PresOralDrugDays: number = 0;
  // PresOtherDrugDays: number = 0;

}
export type SettingValue = string | boolean | number;

export type RatingSettings = {
  [key: string]: SettingValue;
};
export class CashierViewer {
  CashierPreview: CashierPreview;
  CaseTps: string[] = [];
  SortedCase: any[] = [];
  IsCaseTps: boolean;
  PharDayCost: number = 0;
  OwnFromSPS: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class RatingPriceService {

  constructor(private histApi: HistApi,
    private clinicData: ClinicDataService,
    private userConfirm: UserConfirmService,
    private api: PricingApi,
    private chiApi: PricingChiApi) {
  }
  isHomeCare = UserCache.getLoginUser().Clinic.TypeIsHomeCare;
  isRecoveryHome = UserCache.getLoginUser().Clinic.TypeIsRecoveryHome;
  priceType: '西' | '中' | '牙' | '藥' = '西';
  cache = new MemoryCache();
  editOption: PricingEditOpt;
  acuteCaseList = ['04', '08', '24', '28', 'A1', 'E1', 'A5'];
  chronicDay: number = 999;
  hasChronicDx = false;
  decalerFreeDay: boolean = false;
  commonUISet = new RatingPrice共同藥品UISet();
  tmSet = new RatingPrice特殊轉代UISet();
  spSametreatOpt: ValueTextPair[] = []
  labHospSPRule= LabHospSPRule
  priceSett: { [key: string]: SettingValue } = {};
  get Is牙() {
    return UserCache.getLoginUser().Clinic.Type == ClinicTypeEnum.DentistClinic || UserCache.getLoginUser().Clinic.Type == ClinicTypeEnum.WesternAndDentistClinic;
  }
  get Is中() {
    return UserCache.getLoginUser().Clinic.Type == ClinicTypeEnum.ChineseClinic;
  }
  get pricingApi(): IPricingApi {
    return this.Is中 ? this.chiApi : this.api
  }
  async getCashierViewer(histRcd: WholeHist, caspcheckOpt, defaultCase: string, hasdrug: boolean = false): Promise<CashierViewer> {
    if (this.Is牙) {
      var feedback = await this.getFromDentist(histRcd, defaultCase);
    } else if (this.Is中) {
      feedback = await this.getFromChiNormal(histRcd, defaultCase);
    } else if (this.priceType == '藥') {
      feedback = await this.getFromPharNormal(histRcd, defaultCase, caspcheckOpt, hasdrug);
    } else {
      feedback = await this.getFromNormal(histRcd, defaultCase, caspcheckOpt, hasdrug);
    }
    feedback.IsCaseTps = feedback.CaseTps != undefined && feedback.CaseTps != null
    if (feedback.IsCaseTps) {
      feedback.IsCaseTps = feedback.CaseTps.length > 0;
    }
    return feedback;
  }
  async getSpsametreatOpt() {
    this.spSametreatOpt = [];
    var dtos = await this.clinicData.GetSpecialSameTreat();
    dtos.filter(dto => dto.IsEnabled).map(dto => {
      let valueTextPair = new ValueTextPair();
      valueTextPair.text = dto.TreatName;
      valueTextPair.value = dto.SameTreatCode;
      this.spSametreatOpt.push(valueTextPair);
    });
  }
  async checkSPsameTreatC() {
    await this.getSpsametreatOpt();
    if (!this.spSametreatOpt) return false;
    return this.spSametreatOpt.some(x => x.value == RegisterConst.SameTreat_C_尿失禁治療)
  }
  async getFromNormal(histRcd: WholeHist, defaultCase: string, caspcheckOpt: string[], hasdrug: boolean = false): Promise<CashierViewer> {
    let is01incase = caspcheckOpt.some(x => x == '01') && !this.isRecoveryHome && hasdrug && ['01', '09'].includes(defaultCase);
    let is09incase = caspcheckOpt.some(x => x == '09') && !this.isRecoveryHome
    var feedBack = new CashierViewer();
    feedBack.CashierPreview = await this.pricingApi.Preview(histRcd, defaultCase, is01incase, is09incase);

    for (var caseTp in feedBack.CashierPreview) {
      feedBack.CaseTps.push(caseTp);
    }

    // 用藥費金額比較取最大的項目  小計不符合現今的規範(小計會因為交付而短少 可能會出現算起來比簡表小的問題)
    feedBack.SortedCase = feedBack.CaseTps.sort((a: string, b: string) => {
      var isSelfpay = histRcd.Register.ICode == '000'
      var subsumA = (feedBack.CashierPreview[a].Injection ?? 0) + (feedBack.CashierPreview[a].Oral ?? 0) + (feedBack.CashierPreview[a].External ?? 0);
      var subsumB = (feedBack.CashierPreview[b].Injection ?? 0) + (feedBack.CashierPreview[b].Oral ?? 0) + (feedBack.CashierPreview[b].External ?? 0);
      if (a == '01' && b == '09') {
        if (isSelfpay) return 1;
        else if (subsumA == subsumB) return -1;
      }
      else if (a == '09' && b == '01') {
        if (isSelfpay) return -1;
        else if (subsumA == subsumB) return 1;
      }
      return subsumA < subsumB ? 1 : subsumA == subsumB ? 0 : -1;
    });
    return feedBack;
  }
  async checkInhomeAcuteCare(histRcd: WholeHist, otherHRxs?: HistOrder[]) {
    var dtos = await this.clinicData.GetSpecialSameTreatRx();
    var ords = otherHRxs ? histRcd.Hist.HRxs.concat(otherHRxs) : histRcd.Hist.HRxs;
    var ordStdArr = ords.map(x => x.Rx.StdCode);
    ordStdArr = Distinct(ordStdArr);
    var wrongMsgAry: string[] = [];
    var isdx = false;
    if (ordStdArr?.length > 0) {
      for (var ordStd of ordStdArr) {
        var dto = dtos.find(x => ordStd == x.RxStdCode);
        if (dto && !NullOrEmptyTrim(dto.ICD10)) {
          // console.log('dto2',dto);
          var dx1 = histRcd.Hist.Dx1;
          // 分割並分類
          var { withDots, withoutDots } = dto.ICD10
            .split(',') // 分割成陣列
            .filter(item => item !== '') // 過濾掉空字串
            .reduce(
              (acc, item) => {
                if (item.includes('...')) {
                  acc.withDots.push(item.replace(/\.\.\./g, '')); // 去掉 ... 並存到 withDots
                } else {
                  acc.withoutDots.push(item); // 存到 withoutDots
                }
                return acc;
              },
              { withDots: [], withoutDots: [] } as { withDots: string[]; withoutDots: string[] }
            );



          if (withoutDots.includes(dx1)) isdx = true;
          else if (withDots.length > 0) {
            for (var dot of withDots) {
              if (dx1.startsWith(dot)) isdx = true;

            }
            if (!isdx) wrongMsgAry.push(`您的醫令${ordStd} '\n'需對應相關的主診斷:${dto.ICD10}`);
          }
          else {
            wrongMsgAry.push(`您的醫令${ordStd} '\n'需對應相關的主診斷:${dto.ICD10}`);
            //
            // return false;
          }
        }
        var item = ords.filter(x => x.Rx.StdCode == ordStd)
          .reduce((sum, item) => sum + (isNaN(Number(item.TotalDose)) ? 0 : Number(item.TotalDose)), 0);
        var num = this.homeAcuteCareWay(ordStd);
        console.log('num', num, item, ordStd)
        if (num > 0 && item > num) {
          wrongMsgAry.push(`您的醫令${ordStd}之總量為${item} \n所需總數需 <=${num}`);
        }
      }
    }
    if (wrongMsgAry.length > 0) {
      await this.userConfirm.showAlert('提示', wrongMsgAry.join('\n'))
      return false;
    }
    else return true;
  }
  homeAcuteCareWay(input: string): number {
    switch (input) {
      case 'P8401C':
      case 'P8402C':
      case 'P8403C':
      case 'P8404C':
        return 10;
      case 'P8405C':
      case 'P8436C':
      case 'P8437C':
      case 'P8438C':
        return 4;
      case 'P8406C':
      case 'P8407C':
      case 'P8408C':
      case 'P8409C':
      case 'P8411C':
      case 'P8413C':
      case 'P8413C':
      case 'P8414C':
        return 7;
      case 'P8410C':
      case 'P8439C':
      case 'P8440C':
      case 'P8415C':
      case 'P8442C':
      case 'P8443C':
      case 'P8444C':
      case 'P8441C':
        return 2;
      default:
        return 0;
    }
  }

  parseAD_Inote(input: string): string {
    if (input?.length !== 2 && input?.length !== 3) return "1";
    else if (input[0] !== '6') return "1";
    else if (!/^[a-zA-Z]$/.test(input[1])) return "1";
    const secondChar = input[1];
    if (/^[ABC]$/.test(secondChar) && input?.length === 2) {
      return secondChar; // 第二個字元為 A、B 或 C，直接返回
    }
    else if (secondChar > "D" || input?.length === 3) {
      return "D"; // 若第二個字元超過 D，返回 D
    }
    return "A"; // 不符合條件時返回空字串
  }
  async getFromDentist(histRcd: WholeHist, defaultCase: string): Promise<CashierViewer> {
    var feedBack = new CashierViewer();

    feedBack.CashierPreview = await this.api.PreviewDentist(histRcd, defaultCase);
    for (var caseTp in feedBack.CashierPreview) {
      feedBack.CaseTps.push(caseTp);
    }

    // 用藥費金額比較取最大的項目  小計不符合現今的規範(小計會因為交付而短少 可能會出現算起來比簡表小的問題)
    feedBack.SortedCase = feedBack.CaseTps.sort((a: string, b: string) => {
      var subsumA = (feedBack.CashierPreview[a].Total ?? 0);
      if (a == '11' && b == '19' && subsumA >= 300) {
        return 1;
      }
      else if (a == '19' && b == '11' && subsumA >= 300) {
        return -1;
      }
      else if (a == defaultCase) return -1;
      else if (b == defaultCase) return 1;
      return 0;
    });

    return feedBack;
  }

  async getFromChiNormal(histRcd: WholeHist, defaultCase: string): Promise<CashierViewer> {
    var feedBack = new CashierViewer();
    feedBack.CashierPreview = await this.chiApi.Preview(histRcd, defaultCase);
    for (var caseTp in feedBack.CashierPreview) {
      feedBack.CaseTps.push(caseTp);
    }
    // 用藥費金額比較取最大的項目  小計不符合現今的規範(小計會因為交付而短少 可能會出現算起來比簡表小的問題)
    feedBack.SortedCase = feedBack.CaseTps.sort((a: string, b: string) => {
      var subsumA = (feedBack.CashierPreview[a].Oral ?? 0);
      var subsumB = (feedBack.CashierPreview[b].Oral ?? 0);
      return subsumA < subsumB ? 1 : subsumA == subsumB ? 0 : -1;
    });
    return feedBack;
  }
  async Init() {
    await this.GetEditOption(DateHelper.today);
  }
  async GetEditOption(regDate: Date = null) {
    var clinic = UserCache.getLoginUser().Clinic;
    var opt = new PricingEditOpt();
    var codes = await this.clinicData.getSystemCodes(['C0020', 'C0050', 'C0070', 'C0080', 'C0090', 'F0040'])
    var opd001 = await this.clinicData.getParam('OPD001');
    opt.deptList = codes['C0020'];
    opt.CaseTP = codes['C0050'];
    if (this.priceType !== '藥') {
      opt.LABTP = codes['C0080'].filter(x => x.ext3 != '3');
      opt.DispTP = codes['C0070'].filter(x => x.ext3 == '' || x.ext3 == '2');
    } else {
      opt.LABTP = codes['C0080'].filter(x => x.ext3 == '3');
      opt.DispTP = codes['C0070'].filter(x => x.ext3 == '3');
    }


    opt.PayTP = codes['C0090'];
    opt.JailTP = codes['F0040'];
    opt.defaultCase = this.defaultCase(clinic, opt.CaseTP.map(x => x.value));
    opt.chronicDay = opd001.ChronicDays;
    this.chronicDay = opt.chronicDay;
    opt.chronicFreq = opd001.ChronicFreq;
    opt.p13 = await this.clinicData.getGPPara(13);
    opt.rxDailyQuota = await this.clinicData.getGPPara(182) == ' ' ? [80, 100] : [100, 120],

      opt.medDiv = !!clinic.MedDivSdate;
    opt.userDept = !NullOrEmptyTrim(UserCache.getLoginUser().DeptCode) ? UserCache.getLoginUser().DeptCode : clinic.MedDeptCode;
    opt.referralopt = [
      { value: "Y", text: "轉診" },
      { value: "N", text: "非轉" },
      { value: "T", text: "轉入" },
    ]
    opt.consultationOpt = [
      { value: "", text: "" },
      { value: "00", text: "巡診" },
      { value: "01", text: "位於醫療資源缺乏地區" },
      { value: "02", text: "醫療資源缺乏巡診" },
      { value: "03", text: "肝炎治療醫療資源不足及山地離" },
      { value: "04", text: "居家醫療照護至山地離島提供" }
    ]
    opt.presNumOpt = [
      { value: "4", text: "4" },
      { value: "5", text: "5" },
      { value: "6", text: "6" },
      { value: "7", text: "7" },
      { value: "8", text: "8" },
      { value: "9", text: "9" },
      { value: "10", text: "10" },
      { value: "11", text: "11" },
      { value: "12", text: "12" },
      { value: "13", text: "13" },
    ]

    var discountPriority = await this.clinicData.GetDiscountPriority(regDate);
    opt.discountPriority = discountPriority.filter(x =>
      [ExpenseItemEnum.All, ExpenseItemEnum.SelfPay, ExpenseItemEnum.ConsultFee,
      ExpenseItemEnum.DrugOwnFee, ExpenseItemEnum.ExamOwnFee].includes(x.ExpenseItem));

    opt.spcTreatList = await this.clinicData.getOptions(OptionTypes.SpcTOption);
    var editOpt2 = await this.pricingApi.GetEditOptions2(regDate);
    this.editOption = Object.assign(opt, editOpt2);
    this.editOption.naturalDisasterRxDto = await this.clinicData.GetNaturalDisasterRx(regDate);
    return this.editOption;
  }
  setPriceUIDays(histRcd: WholeHist): DaysInfo {
    var feedback = new DaysInfo();
    var histDay = histRcd.Hist.Days || 0;
    //加上中醫102, 202, 203
    var checkList = [Number(OrderTypeEnum.T2_OralDrugFee), Number(OrderTypeEnum.T3_ExtDrugFee), Number(OrderTypeEnum.T4_InjectionDrugFee),
    Number(OrderTypeEnum.T102_SelfPaymentDrug), Number(OrderTypeEnum.T202_DrugSet), Number(OrderTypeEnum.T203_WaterMedicineSet)];
    var checkSPRuleList = [2, 3, 4];
    if (histRcd.Register.ICode == '000') checkSPRuleList = [];
    var getDays = histRcd.Hist.HRxs.filter(x => x.RxCode == '/7' || (checkList.some(y => y == x.RxType) && !NullOrEmptyTrim(x.StdCode || x.Rx?.StdCode) && !checkSPRuleList.some(y => y == x.SPRule))).sort((a, b) => a.Sort - b.Sort);;
    var maxDayOral = 0;
    var maxDayOther = 0;
    var maxDayOralPres = 0;
    var maxDayOtherPres = 0;
    var is7 = false;
    if (getDays.length > 0) {
      for (const o of getDays) {
        if (o.RxCode == '/7') {
          is7 = true;
        }
        let days = !isNaN(Number(o.Days)) && Number(o.Days) !== 0 ? Number(o.Days)
          : (!isNaN(Number(o.InfoDays)) ? Number(o.InfoDays) : 0);
        //加上中醫102, 202, 203
        // if (o.RxType == OrderTypeEnum.T2_OralDrugFee) {
        if (MedRxType.includes(o.RxType)) {
          if (maxDayOral < days) {
            maxDayOral = days;
            if (!is7) maxDayOralPres = days;
          }
        } else if (o.RxType == OrderTypeEnum.T3_ExtDrugFee || o.RxType == OrderTypeEnum.T4_InjectionDrugFee) {
          if (maxDayOther < days) {
            maxDayOther = days;
            if (!is7) maxDayOtherPres = days;
          }
        }
      };

    }
    let hasChronicDx = this.acuteCaseList.some(x => x == histRcd.Hist.Case)  ? true : this.hasChronicDx;

    feedback.PresDays = maxDayOralPres > 0 ? maxDayOralPres : maxDayOtherPres;
    feedback.NormalDays = maxDayOral > 0 ? maxDayOral : maxDayOther;
    feedback.isApplyingPres = feedback.PresDays >= this.chronicDay;
    hasChronicDx = hasChronicDx && !NullOrEmptyTrim(histRcd.Hist.CntPresTot) && DispensingGroup.符合慢性病的調劑.includes(histRcd.Hist.DispTP as DispensingTypeEnum) && feedback.isApplyingPres;

    if (hasChronicDx) {
      feedback.DrugDays = maxDayOralPres > 0 ? maxDayOralPres : maxDayOtherPres;
    }
    else {
      feedback.DrugDays = maxDayOral > 0 ? maxDayOral : maxDayOther;
    }
    console.log('decalerFreeDay', this.decalerFreeDay);
    if (this.decalerFreeDay) {
      let beEditDay = getDays.find(x => x.RxCode != '/7' && (histDay == x.Days || histDay == x.InfoDays))
      if (beEditDay) {
        feedback.DrugDays = beEditDay.InfoDays == histDay ? beEditDay.InfoDays : beEditDay.Days;
        feedback.isApplyingPres = feedback.DrugDays >= this.chronicDay;

      }
    }
    return feedback;
  }

  /** 判斷目前病歷是否符合慢箋登打條件 */
  isChronicPrescriptionEligible(histRcd: WholeHist, days?: DaysInfo): boolean {
    if (!histRcd?.Hist) return false;

    const hasEligibleCase = this.acuteCaseList.some(x => x == histRcd.Hist.Case);
    const hasEligibleDispensing = DispensingGroup.符合慢性病的調劑.includes(histRcd.Hist.DispTP as DispensingTypeEnum);
    const hasChronicDx = hasEligibleCase
      ? true
      : histRcd.Register?.SameTreat == RegisterConst.SameTreat_8_慢箋領藥
        ? true
        : this.hasChronicDx;
    const isApplyingPres = (days ?? this.setPriceUIDays(histRcd)).isApplyingPres;

    return hasEligibleCase && hasEligibleDispensing && hasChronicDx && isApplyingPres;
  }

  private defaultCase(clinic: Clinic, caseCode: string[]): string {

    if (clinic.TypeIsRecoveryHome && caseCode.includes("A2")) {
      return "A2";
    }
    else if (clinic.TypeIsHomeCare && caseCode.includes("A1")) {
      return "A1";
    }

    if (clinic.Type == ClinicTypeEnum.DentistClinic || clinic.Type == ClinicTypeEnum.WesternAndDentistClinic) {
      if (caseCode.includes("19")) {
        return "19";   // 09為目前現行初始的案類
      }
      if (caseCode.includes("11")) {
        return "11";
      }
    } else if (clinic.Type == ClinicTypeEnum.ChineseClinic) {
      return "21";
    } else {
      if (caseCode.includes("09")) {
        return "09";   // 09為目前現行初始的案類
      }
      if (caseCode.includes("01")) {
        return "01";
      }
    }
    return caseCode[0] ?? '';
  }


  update(key: string, value: SettingValue) {
    this.priceSett[key] = value;
  }


  settGet<T extends SettingValue>(key: string): T {
    return this.priceSett[key] as T;
  }
  // 未完待續
  // initRatingSettFor西醫() {
  //   for (const key in DEFAULT_西醫_RATING_SETTINGS) {
  //     this.update(key, DEFAULT_西醫_RATING_SETTINGS[key]);
  //   }

  // }
  setPrice西醫UIDisp(histRcd: WholeHist) {
    this.commonUISet.hasPharmacist = this.editOption?.Pharmarcist?.length > 0;
    // 有無藥品醫令
    this.commonUISet.hasDrug = false;
    this.commonUISet.hasNeedleDrug = false;
    this.commonUISet.has二類三類 = false;
    var hasDWithNumber = false;
    // 有無交付醫令
    var hasOutClinic = false;
    var hasClinic = false;
    var isAbleToDoEmerSelf = histRcd.Hist.Case != 'C1' && histRcd.Hist.Case != 'D2' && histRcd.Register.SameTreat != RegisterConst.SameTreat_0_洗腎

    var sencondAdPh = false;
    const hrx = Object.assign([], histRcd.Hist.HRxs);

    var hasOnlySelfPayDrugs = false; // 只有自費藥
    var checkList = [OrderTypeEnum.T2_OralDrugFee, OrderTypeEnum.T3_ExtDrugFee, OrderTypeEnum.T4_InjectionDrugFee];
    var drugOrders = hrx.filter(o => checkList.includes(o.RxType));
    hasOnlySelfPayDrugs = drugOrders.length > 0 && drugOrders.every(o => o.SPRule == 2 || o.SPRule == 3 || o.SPRule == 4);

    for (var o of hrx) {
      if ([2, 3, 6, 7].indexOf(o.RxType) >= 0) {
        let spRule = histRcd.Register.ICode == '000' ? true : (o.SPRule < 2 || o.SPRule == 5);
        if (o.RxType == 6 || o.RxType == 7) {
          if (['23', '24', '26', '28'].indexOf(o.Rx.StdCode) >= 0) sencondAdPh = true;
          if (!sencondAdPh) this.commonUISet.hasExam = true;
        }
        if ((o.RxType !== 6 && o.RxType !== 7) && o.DispTP == OrderDispensingTypeEnum.T1_OutOfClinic && spRule) {
          this.commonUISet.hasDrug = true;
          hasOutClinic = true;
          this.commonUISet.has二類三類 = true;
        } else if ((o.RxType !== 6 && o.RxType !== 7) && o.DispTP == OrderDispensingTypeEnum.T0_Clinic && spRule) {
          this.commonUISet.hasDrug = true;
          this.commonUISet.has二類三類 = true;
          hasClinic = true;
        }
      }
      else if (o.RxType == 4 && (o.SPRule === 0 || o.SPRule === 5 || o.SPRule === 1 || o.SPRule === 9)) {
        this.commonUISet.hasDrug = true;
        if (o.DispTP == OrderDispensingTypeEnum.T1_OutOfClinic) hasOutClinic = true;
        else if (o.DispTP == OrderDispensingTypeEnum.T0_Clinic) hasClinic = true;
        this.commonUISet.hasNeedleDrug = true;
        if (!hasDWithNumber) hasDWithNumber = (/D\d+/.test(o.Rx?.BoxUnit || '')) || o.Rx?.BoxUnit == 'D';
      }
    }
    // 疫苗類直接判成自調
    if (histRcd.Hist.Case == 'D2') {
      histRcd.Hist.DispTP = DispensingTypeEnum.Clinic;
    }
    // 有開藥
    else if (this.commonUISet.hasDrug) {
      // 有任一交付 則調劑方式為交付
      // if (histRcd.Hist.PharmacistId == 0 && this.commonUISet.has二類三類 && this.commonUISet.hasDrug) hasOutClinic = true;
      if (this.commonUISet.hasNeedleDrug && !this.commonUISet.has二類三類) {
        if (hasDWithNumber) histRcd.Hist.DispTP = DispensingTypeEnum.Clinic; // 洗腎EPO 自調
        else if (histRcd.Hist.PharmacistId == 0 && o.SPRule !== 9 && !hasOutClinic && isAbleToDoEmerSelf) histRcd.Hist.DispTP = DispensingTypeEnum.EmerSelf;
        else if (hasOutClinic) histRcd.Hist.DispTP = DispensingTypeEnum.OutOfClinic;
        else histRcd.Hist.DispTP = DispensingTypeEnum.Clinic;
      }
      else if (hasOutClinic) {
        histRcd.Hist.DispTP = DispensingTypeEnum.OutOfClinic;
        if (!hasClinic) histRcd.Hist.PharmacistId = 0
      }
      else if (hasClinic && histRcd.Hist.PharmacistId == 0 && isAbleToDoEmerSelf) {
        histRcd.Hist.DispTP = DispensingTypeEnum.EmerSelf;
      }
      // 無交付下才為自調
      else {
        histRcd.Hist.DispTP = DispensingTypeEnum.Clinic;
        //維持原有藥師
        this.commonUISet.selectedPharm = histRcd.Hist.PharmacistId;
      }
    }
    // 未開藥
    else if (!this.commonUISet.hasDrug) {
      if (this.commonUISet.hasInjectionSelfDisp) histRcd.Hist.DispTP = DispensingTypeEnum.Clinic;
      if (hasOutClinic) histRcd.Hist.DispTP = DispensingTypeEnum.OutOfClinic;
      else histRcd.Hist.DispTP = DispensingTypeEnum.NoNeed;
    }
    if ((histRcd.Hist.DispTP == DispensingTypeEnum.NoNeed && !hasOnlySelfPayDrugs) || histRcd.Hist.DispTP == DispensingTypeEnum.EmerSelf) {
      histRcd.Hist.PharmacistId = 0;
    }
  }

  async getFromPharNormal(histRcd: WholeHist, defaultCase: string, caspcheckOpt: string[], hasdrug: boolean = false): Promise<CashierViewer> {
    let is01incase = caspcheckOpt.some(x => x == '01') && !this.isRecoveryHome && hasdrug && ['01', '09'].includes(defaultCase);
    let is09incase = caspcheckOpt.some(x => x == '09') && !this.isRecoveryHome
    var feedBack = new CashierViewer();
    feedBack.CashierPreview = await this.api.PreviewPharmacy(histRcd, defaultCase, is01incase, is09incase);
    if (this.priceType == '藥') {
      const keys = Object.keys(feedBack.CashierPreview);
      if (keys.length > 0) {
        feedBack.PharDayCost = feedBack.CashierPreview[keys[0]]?.PharDayCost ?? 0;
        feedBack.OwnFromSPS = feedBack.CashierPreview[keys[0]]?.OwnFromSPS ?? false;
      }
    }

    for (var caseTp in feedBack.CashierPreview) {
      feedBack.CaseTps.push(caseTp);
    }

    // 用藥費金額比較取最大的項目  小計不符合現今的規範(小計會因為交付而短少 可能會出現算起來比簡表小的問題)
    feedBack.SortedCase = feedBack.CaseTps.sort((a: string, b: string) => {
      var isSelfpay = histRcd.Register.ICode == '000'
      var subsumA = (feedBack.CashierPreview[a].Injection ?? 0) + (feedBack.CashierPreview[a].Oral ?? 0) + (feedBack.CashierPreview[a].External ?? 0);
      var subsumB = (feedBack.CashierPreview[b].Injection ?? 0) + (feedBack.CashierPreview[b].Oral ?? 0) + (feedBack.CashierPreview[b].External ?? 0);
      if (a == '01' && b == '09') {
        if (isSelfpay) return 1;
        else if (subsumA == subsumB) return -1;
      }
      else if (a == '09' && b == '01') {
        if (isSelfpay) return -1;
        else if (subsumA == subsumB) return 1;
      }
      return subsumA < subsumB ? 1 : subsumA == subsumB ? 0 : -1;
    });
    return feedBack;
  }
  checkSpecItem(histRcd: WholeHist,dxsp:string[]=[]){
    var reg = histRcd.Register;
    var declare = histRcd.Hist;
        if (reg.SameTreat === '0') {
          dxsp.unshift('D8');
        }

        const e1hasMatchEC =declare.Case == 'E1' && declare.HRxs.some(item => PriceNhiDrugcodes.居整AllstdCodes.includes(item.StdCode)); // 回傳 true / false
        var isEC = this.isHomeCare ? histRcd.Patient.PaySysA == 'NI':  true;
        // EC For 居家整合計畫 所以它必須滿足  收案別為整合類且案類為E1 A1 A5
        if ((e1hasMatchEC || declare.Case == 'A1' || declare.Case == 'A5') && isEC) {
          dxsp.unshift('EC');
        }
        if (reg.SameTreat == RegisterConst.SameTreat_F_在宅計畫) dxsp.unshift('EN');
        //代謝症候群防治計畫
        //案件分類由「09：西醫其他專案」改為「A3：預防保健」，並應填部分負擔代號「009：其他規定免部分負擔者」、就醫序號「MSPT：代謝症候群防治計畫之個案收案、追蹤及年度評估」。
        if (reg.Icno == RegisterConst.Icno_Metabolic_Syndrome) {
          dxsp.unshift('EM');
        }
  }
  checkEmerSpICD10Cond(code: string): boolean {
    if (!code) return false;

    // 移除點號並轉大寫，統一比對格式
    const cleanCode = code.replace(/\./g, '').toUpperCase();
    const lastChar = cleanCode.slice(-1);
    const prefix3 = cleanCode.substring(0, 3);
    const prefix2 = cleanCode.substring(0, 2);

    // (1) T07.XXXA
    if (cleanCode.startsWith('T07') && lastChar === 'A') return true;

    // (2) 第七位為 A 的範圍
    const rangeA = ['S00', 'S01', 'T79']; // 單獨的碼
    const isS03_S11 = (prefix3 >= 'S03' && prefix3 <= 'S11');
    const isS13_S17 = (prefix3 >= 'S13' && prefix3 <= 'S17');
    const isS19_S21 = (prefix3 >= 'S19' && prefix3 <= 'S21');
    const isS23_S51 = (prefix3 >= 'S23' && prefix3 <= 'S51');
    const isS53_S61 = (prefix3 >= 'S53' && prefix3 <= 'S61');
    const isS63_S71 = (prefix3 >= 'S63' && prefix3 <= 'S71');
    const isS73_S81 = (prefix3 >= 'S73' && prefix3 <= 'S81');
    const isS83_S91 = (prefix3 >= 'S83' && prefix3 <= 'S91');
    const isS93_S99 = (prefix3 >= 'S93' && prefix3 <= 'S99');

    if ((rangeA.includes(prefix3) || isS03_S11 || isS13_S17 || isS19_S21 ||
      isS23_S51 || isS53_S61 || isS63_S71 || isS73_S81 || isS83_S91 || isS93_S99)
      && lastChar === 'A') {
      return true;
    }

    // (3) 第七位為 A 或 B 的範圍 (S02, S12, S22, S32, S42, S62, S92, S99)
    const rangeAB = ['S02', 'S12', 'S22', 'S32', 'S42', 'S62', 'S92', 'S99'];
    if (rangeAB.includes(prefix3) && (lastChar === 'A' || lastChar === 'B')) return true;

    // (4) 第七位為 A, B, C 的範圍 (S52, S72, S82)
    const rangeABC = ['S52', 'S72', 'S82'];
    if (rangeABC.includes(prefix3) && ['A', 'B', 'C'].includes(lastChar)) return true;

    // (5) 重大燒傷診斷碼判斷 (不含體表面積 >20% 邏輯，需由外部數值提供)
    // T31.20-T31.99, T32.20-T32.99
    if ((prefix3 === 'T31' || prefix3 === 'T32')) {
      const subCode = parseFloat(cleanCode.substring(3, 5));
      if (subCode >= 20 && subCode <= 99) return true;
    }

    // 其他特定燒傷碼 (需符合 XA 結尾)
    const specificBurns = [
      /^T20[37][0-9]XA$/, // T20.30XA-T20.39XA, T20.70XA-T20.79XA
      /^T2600XA$/,        // T26.00XA
      /^T2692XA$/         // T26.92XA
    ];
    if (specificBurns.some(reg => reg.test(cleanCode))) return true;

    return false;
  }
  getCaseStdCodes(HRxs: HistOrder[]):string{
    var feedback = '';
    var stdcodes = HRxs.map(x => x.StdCode);
    if(stdcodes.some(x => PriceNhiDrugcodes.康家AllStdCodes.some(y => y == x))){
        feedback = 'A2';
    }
    return feedback;
  }
    getDeptbyStdCodes(HRxs: HistOrder[]):string{
    var feedback = '';
    var stdcodes = HRxs.map(x => x.StdCode);
    if(stdcodes.some(x => PriceNhiDrugcodes.康家AllStdCodes.some(y => y == x))){
        feedback = '13';
    }
    return feedback;
  }
}
